import { makeStyles } from '@material-ui/core'

// Mirrors SupportTabs' styles, which mirror InventoryTabs' — the negative
// margins cancel the page padding so the tab strip spans the full width. That
// full-bleed is what makes the strip read as page chrome rather than as
// content, and it is the difference the eye actually registers between a
// house tab shell and a bare <Tabs>.
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    marginRight: -96,
    marginLeft: -96,
    marginTop: -20,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  tabPanel: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  // The boxed selected tab. borderTop is dropped so the box opens upward into
  // the strip rather than closing a rectangle around the label.
  tab: {
    fontSize: 14,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    }
  }
}))

export default useStyles
